import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "./Panel";
import { WordingPeriodForm } from "./WordingPeriodForm";

export const CheckoutWordingPanel = ({ admin, onChange }) => {
  const [w, setW] = useState(null);
  const [pv, setPv] = useState(null);
  const [confirm, setConfirm] = useState("");
  const [note, setNote] = useState("");
  const load = useCallback(() => {
    api.get("/email-marketing/launch/checkout-wording").then((r) => setW(r.data)).catch(() => {});
    api.get("/email-marketing/launch/checkout-verification/preview").then((r) => setPv(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const save = async (periods) => {
    try { await api.put("/email-marketing/launch/checkout-wording", { periods }); toast.success("Wording periods saved"); load(); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
  };
  const apply = async () => {
    try { const r = await api.post("/email-marketing/launch/checkout-verification/apply", { confirm, note }); toast.success(`${r.data.verified} subscribers verified`); setConfirm(""); load(); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not verify"); }
  };
  if (!w) return null;
  return (
    <Panel testid="launch-checkout" title="1. Historical WooCommerce checkout consent (MC4WP)"
      sub="Each checkout tick is stored against the subscriber with order numbers and dates. Record the checkbox wording, pre-ticked setting and dates it applied, with where that evidence came from. Only ticks inside a verified, not pre-ticked, marketing-worded period can become consent; later unticked orders are held for review.">
      {pv && <div className="flex flex-wrap gap-3 text-xs" data-testid="launch-checkout-preview">
        <span>Candidates: <b>{pv.candidates.toLocaleString()}</b></span>
        {Object.entries(pv.outcomes).map(([k, v]) => <span key={k}>{k.replace(/_/g, " ")}: <b>{v.toLocaleString()}</b></span>)}</div>}
      <ul className="text-xs space-y-1" data-testid="launch-wording-list">{w.periods.map((p) => (
        <li key={p.id} className="border rounded-lg p-2"><b>{p.effective_from} → {p.effective_to || "open"}</b> · pre-ticked {p.pre_ticked ? "yes" : "no"} · marketing wording {p.mentions_marketing ? "yes" : "no"}<br />
          “{p.label_text}”<br /><span className="text-slate-500">Evidence: {p.evidence_reference}</span></li>))}
        {!w.periods.length && <li className="text-slate-400">No wording periods recorded yet.</li>}</ul>
      {admin && <WordingPeriodForm onAdd={(p) => save([...w.periods, p])} />}
      {admin && pv?.would_verify > 0 && <div className="flex flex-wrap items-end gap-2 border-t pt-3">
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason / who checked the evidence" className="max-w-sm h-9" data-testid="launch-apply-note" />
        <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder={`Type ${w.confirm_phrase}`} className="max-w-xs h-9" data-testid="launch-apply-confirm" />
        <Button size="sm" disabled={confirm !== w.confirm_phrase || note.length < 10} onClick={apply} data-testid="launch-apply-btn">Verify {pv.would_verify.toLocaleString()} subscribers</Button></div>}
    </Panel>
  );
};
